import React, {PropTypes, Component} from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import _ from 'lodash';
import {Line as LineChart} from 'react-chartjs'; //stacked bar? @see https://github.com/Regaddi/Chart.StackedBar.js/blob/master/src/Chart.StackedBar.js
import {serverToDisplayTimeSlot, serverToDisplayTime} from 'app/lib/format';
import Widget from '../../Widget';
import Preloader from 'routes/app/components/Preloader';
import Input from 'routes/app/components/Input';
import Col from 'routes/app/components/Col';
import Row from 'routes/app/components/Row';
import {colorsRGB} from 'app/globals';

const chartOptions = {
    showScale: true,
    scaleShowLabels: false,
    showTooltips: false,
    responsive: true,
    maintainAspectRatio: false
};

const rawDataToChartData = ({values, maxRefMinutes}) => {


    const data = {labels: [], datasets: []};

    if (_.isEmpty(values)) {
        return data;
    }

    // values = [{"begin":"060000","end":"100000","avgLeadTime":120},{"begin":"100000","end":"120000","avgLeadTime":40},{"begin":"120000","end":"150000","avgLeadTime":120},{"begin":"150000","end":"213000","avgLeadTime":90}];

    // Dummy dataset, to always keep values between 0 and maxRefMinutes
    let dataSet0 = {
        fillColor: 'transparent',
        pointColor: 'transparent',
        strokeColor: 'transparent',
        data: [0,maxRefMinutes]
    };

    let dataSet1 = {
        label: 'Max. registrations',
        fillColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},0.2)`,
        strokeColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},1)`,
        pointColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},1)`,
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(151,187,205,1)',
        data: []
    };

    if (values.length > 1) {
        for (let timeSlot of values) {
            data.labels.push(serverToDisplayTimeSlot(timeSlot.begin, timeSlot.end));
            dataSet1.data.push(timeSlot.avgLeadTime);
        }
    } else if (values.length === 1) {
        data.labels.push(serverToDisplayTime(values[0].begin));
        data.labels.push(serverToDisplayTime(values[0].end));
        dataSet1.data.push(values[0].avgLeadTime);
        dataSet1.data.push(values[0].avgLeadTime);
    }

    data.datasets = [dataSet0, dataSet1];

    return data;
};

class AverageLeadTime extends Component {

    static propTypes = {
        rawData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        intl: PropTypes.object,
        fetch: PropTypes.func.isRequired,
        dayOfWeekField: PropTypes.object,
        values: PropTypes.shape({
            dom: PropTypes.string,
            dayOfWeek: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        })
    };

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.values.dom !== nextProps.values.dom || this.props.values.dayOfWeek !== nextProps.values.dayOfWeek) {
            this.fetchData(nextProps.values.dom, nextProps.values.dayOfWeek);
        }
    }

    fetchData = (dom, dayOfWeek) => {
        dom = dom || this.props.values.dom;
        dayOfWeek = dayOfWeek || this.props.values.dayOfWeek;
        this.props.fetch({dom, dayOfWeek});
    };

    render() {
        const {rawData, intl:{formatMessage}, dayOfWeekField} = this.props;

        return (
            <Widget
                onRefresh={this.fetchData}
                title={
                     <FormattedMessage id="dashboard.averageLeadTime.title" />}>

                <Row>
                    <Col s={8} offset="s2">
                        <Input s={12} type="select" {...dayOfWeekField}>
                            {_.map([1,2,3,4,5,6,7], (day) => (
                                <option value={day} key={day}>{moment().isoWeekday(day).format('dddd')}</option>
                            ))}
                        </Input>
                    </Col>
                </Row>

                {rawData.isLoading ?
                    <Preloader />
                    :
                    rawData.isError ?
                        <FormattedMessage id="dashboard.averageLeadTime.fetchError" />
                        :
                        !rawData.values || rawData.values.length === 0 ?
                            <FormattedMessage id="dashboard.averageLeadTime.empty" />
                            :
                            <div>
                                <LineChart data={rawDataToChartData(rawData)} options={chartOptions} height="200"/>
                            </div>
                }
            </Widget>
        );
    }

}

export default AverageLeadTime;